<div class="modal-header">
  <h4 class="modal-title">{{ modalTitle }}</h4>
  <button (click)="onClose()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<div class="modal-body">
  @if (tooltip) {
    <div class="text-end w-100 tooltip-container">
      <i class="bi bi-info-circle-fill" role="button" data-bs-toggle="tooltip" [attr.data-bs-title]="tooltip"></i>
    </div>
  }
  <div class="text-center p-4" style="white-space: pre-line">
    {{ confirmationText }}
  </div>
</div>
<div class="modal-footer d-flex justify-content-center">
  <div class="container w-100">
    <div class="row gx-5 gy-3">
      <div
        [hidden]="hideConfirmButton"
        class="col-12 px-2"
        [class.col-lg-12]="numberOfActiveButtons() === 1"
        [class.col-lg-6]="numberOfActiveButtons() === 2"
        [class.col-lg-4]="numberOfActiveButtons() === 3"
        >
        <button (click)="onConfirm()" class="btn btn-primary w-100 h-100" [class.double-height]="highlightConfirm">
          {{ confirmButtonLabel }}
        </button>
      </div>
      <div
        [hidden]="!confirmButton2Label"
        class="col-12 px-2"
        [class.col-lg-12]="numberOfActiveButtons() === 1"
        [class.col-lg-6]="numberOfActiveButtons() === 2"
        [class.col-lg-4]="numberOfActiveButtons() === 3"
        >
        <button (click)="onConfirm2()" class="btn btn-primary w-100 h-100" [class.double-height]="highlightConfirm">
          {{ confirmButton2Label }}
        </button>
      </div>
      <div
        [hidden]="hideCancelButton"
        class="col-12 px-2"
        [class.col-lg-12]="numberOfActiveButtons() === 1"
        [class.col-lg-6]="numberOfActiveButtons() === 2"
        [class.col-lg-4]="numberOfActiveButtons() === 3"
        >
        @if (!highlightConfirm) {
          <button (click)="onCancel()" class="btn btn-outline-primary w-100 h-100">
            {{ cancelButtonLabel }}
          </button>
        }
        @if (highlightConfirm) {
          <div
            class="w-100 h-100 d-flex justify-content-center align-items-center text-center"
            >
            <a (click)="onCancel()" class="w-100" role="button">{{ cancelButtonLabel }}</a>
          </div>
        }
      </div>
    </div>
  </div>
</div>
